import { createContext, useContext, useState, useMemo, useEffect, useCallback } from "react";
import translations from "@/i18n/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "fbs_language";

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "it";
    return window.localStorage.getItem(STORAGE_KEY) || "it";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = useMemo(() => translations[lang] || translations.it, [lang]);
  const toggle = useCallback(() => setLang((l) => (l === "it" ? "en" : "it")), []);

  const value = useMemo(
    () => ({ lang, setLang, toggle, t }),
    [lang, t, toggle]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
